module.exports = require("https");


/*****************
 ** WEBPACK FOOTER
 ** external "https"
 ** module id = 48
 ** module chunks = 0
 **/